/* eslint-disable sonarjs/no-duplicate-string */
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colors } from 'styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    backgroundAdornmentsSection: {
      height: '60vh',
      position: 'absolute',
      zIndex: 0,
      [theme.breakpoints.down('sm')]: {
        opacity: 0,
      },
    },
    backgroundEllipseSection: {
      height: '90%',
      left: '68vw',
      overflow: 'hidden',
      position: 'absolute',
      top: '1%',
      zIndex: 0,
      [theme.breakpoints.down('sm')]: {
        height: '40%',
        left: 0,
      },
    },
    backgroundRedDotsSection: {
      left: '45vw',
      position: 'absolute',
      top: '40vh',
      [theme.breakpoints.down('sm')]: {
        left: 0,
        top: '20%',
        width: '20%',
      },
    },
    backgroundWSection: {
      height: '80%',
      left: '30vw',
      opacity: 0.3,
      overflow: 'visible',
      position: 'absolute',
      top: '8%',
      zIndex: 0,
      [theme.breakpoints.down('sm')]: {
        opacity: 1,
        right: 0,
        top: '1%',
        width: '110%',
      },
    },
    carousel: {
      flex: 1,
      padding: '0 3vw',
    },
    detailsTextOneFullWidth: {
      alignItems: 'center',
      color: colors.white,
      display: 'flex',
      fontSize: '1rem',
      fontWeight: 500,
      margin: '1vh 0',
      textAlign: 'left',
      textShadow: '2px 2px 2px rgba(100, 100, 100, 0.2)',
      width: '80%',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        fontSize: '0.8rem',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
      },
    },
    icon: {
      margin: '0 0.5vw',
    },
    knowMoreButton: {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      height: '6vh',
      margin: '2vh 0',
      minHeight: '60px',
      width: '40%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
        lineHeight: '1rem',
      },
    },
    linkButton: {
      width: '100%',
      alignContent: 'center',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      color: colors.textGrey3e,
      textDecoration: 'none',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
      },
    },
    oneFullWidth: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      padding: '0 4vw',
      width: '100%',
      zIndex: 999,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        height: '85vh',
        margin: '2vh 0 2vh',
        minHeight: '400px',
        padding: 0,
      },
    },
    oneFullWidthImage: {
      alignSelf: 'center',
      backgroundPosition: 'center 30%',
      backgroundSize: 'cover',
      borderRadius: 20,
      boxShadow: `-25px 20px 44px 0 ${colors.battleshipGrey}`,
      color: colors.textGrey3e,
      display: 'flex',
      height: '80%',
      textAlign: 'center',
      width: '32vw',
      zIndex: 0,
      [theme.breakpoints.down('sm')]: {
        boxShadow: `-25px 20px 44px 0 ${colors.battleshipGrey}`,
        flex: 1,
        height: 'auto',
        minHeight: '240px',
        width: '100%',
      },
    },
    oneFullWidthLeft: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'flex-start',
        padding: '1vh 0',
        minHeight: '160px',
      },
    },
    oneFullWidthRight: {
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-start',
      height: '40vh',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        margin: '-5vh 0',
        width: '100%',
      },
    },
    root: {
      alignItems: 'center',
      animation: `$Senses 30s ${theme.transitions.easing.easeInOut} infinite`,
      background: 'linear-gradient(270deg, #ff8900, #ff0000, #0065db, #db0000)',
      backgroundSize: '1000% 1000%',
      display: 'flex',
      flexDirection: 'row',
      height: '45vh',
      minHeight: '460px',
      padding: '70px 4vw 0',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        height: '85vh',
        margin: '4vh 0 2vh',
        minHeight: '400px',
        padding: '20px 4vw',
      },
    },
    '@keyframes Senses': {
      '0%': {
        backgroundPosition: '0% 50%',
      },
      '50%': {
        backgroundPosition: '100% 50%',
      },
      '100%': {
        backgroundPosition: '0% 50%',
      },
    },
    tags: {
      // border: `1px solid ${colors.white}`,
      // borderRadius: '10px',
      backgroundColor: colors.greyBrand,
      color: colors.white,
      fontSize: '0.8rem',
      margin: '0 0.5vw',
      textAlign: 'center',
      textShadow: '2px 2px 2px rgba(100, 100, 100, 0.2)',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        margin: '1vh 0',
        textAlign: 'center',
        width: '100%',
      },
    },
    tagsGrid: {
      display: 'flex',
      flexDirection: 'row',
    },
    titleOneFullWidth: {
      color: colors.white,
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textAlign: 'left',
      textShadow: '2px 2px 2px rgba(100, 100, 100, 0.2)',
      width: '80%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.6rem',
        textAlign: 'center',
        width: '90%',
      },
    },
    titleTextOneFullWidth: {
      color: colors.white,
      fontSize: '1.2rem',
      margin: '1vh 0 2vh',
      textAlign: 'left',
      width: '80%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        margin: '1vh 0',
        textAlign: 'center',
        width: '80%',
      },
    },
  })
);
